<template>
    <div class="content_box mobile_content">
        <div class="content role">
            <div class="title_box">
                <span class="title">APP 商城管理</span>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addMall" v-if="roleCheck('103-102-101-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="activity_name" label="活动名称"  width="140px"></el-table-column>
                <el-table-column label="页面位置" width="160px">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.position == 'home'">首页</span>
                        <span v-if="scope.row.position == 'mao'">猫砂盆详情页</span>
                        <span v-if="scope.row.position == 'air'">空气进化器</span>
                        <span v-if="scope.row.position == 'water'">饮水机</span>
                    </template>
                </el-table-column>
                <el-table-column prop="begin_time" label="生效时间" width="160px"></el-table-column>
                <el-table-column prop="jump_url" show-overflow-tooltip label="活动链接"></el-table-column>
                <el-table-column label="标签" width="60px">
                    <template slot-scope="scope" >
                        <img :src="scope.row.icon_url" alt="">
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100px">
                    <template slot-scope="scope" >
                        <span class="state state2" v-if="scope.row.status == 0">生效中</span>
                        <span class="state state1" v-else-if="scope.row.status == 1">已结束</span>
                    </template>
                </el-table-column>
                <el-table-column prop="group_name" label="群组">
                    <template slot-scope="scope" >
                        <span>{{scope.row.group_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateStatus(scope.row, 1)" v-if="roleCheck('103-102-100-102') && scope.row.status == 0">结束</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Tip ref="tip" msg="确定结束该活动？">
                <template v-slot:confirm_btn>
                    <div class="button del" @click="updateStatusConfirm">
                        <span>确认</span>
                    </div>
                </template>
            </Tip>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <el-form-item label="活动名称" prop="activity_name">
                            <el-input v-model="actData.activity_name" maxlength="100" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="页面位置" prop="position">
                            <el-select v-model="actData.position" placeholder="请选择">
                                <el-option label="首页" value="home"></el-option>
                                <el-option label="猫砂盆详情页" value="mao"></el-option>
                                <el-option label="空气净化器" value="air"></el-option>
                                <el-option label="饮水机" value="water"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生效时间" prop="start_time">
                            <el-date-picker v-model="actData.begin_time" type="datetime" :editable="true"
                                format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间"
                                value-format="yyyy-MM-dd HH:mm:ss" popper-class="time">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="跳转地址" prop="jump_url">
                            <el-input v-model="actData.jump_url" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="活动标签" prop="icon_url">
                            <el-select v-model="actData.icon_url" clearable placeholder="请选择">
                                <el-option :label="item.name" :value="item.url" v-for="item in  tag" :key="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="群组">
                            <el-select v-model="groupList" multiple placeholder="请选择">
                                <el-option :label="item.group_name" :value="item.id" v-for="(item, i) in group" :key="i + '43324'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'app-mall-manage',
    data() {
        return {
            searchData: {
                page_size: 10,
                page: 1
            },
            listData: [],
            total: 0,
            dislog: {
                type: '',
                title: ''
            },
            group: [],
            groupList: [],
            actData: {},
            delListId: '',
            tag: [{
                name: "折扣",
                url: 'https://src-cn.oss-cn-hangzhou.aliyuncs.com/file/sale_cn.png'
            },{
                name: '新品',
                url: 'https://src-cn.oss-cn-hangzhou.aliyuncs.com/file/new_cn.png'
            },{
                name: "SALE",
                url: 'https://src-en.oss-ap-southeast-1.aliyuncs.com/file/sale.png'
            },{
                name: 'NEW',
                url: 'https://src-en.oss-ap-southeast-1.aliyuncs.com/file/new.png'
            }],
            formRule: {
                activity_name: [this.requiredRule('请输入活动名称')],
                position: [this.requiredRule('请选择页面位置')],
                begin_time: [{required: true, message: '请选择生效时间', trigger: 'change', type: 'date'}],
                jump_url: [this.requiredRule('请输入跳转地址')]
            },
        }
    },
    created() {
        this.getMallList();
        this.getGroupList();
    },
    methods: {
        addMall() {
            this.dislog = {
                type: 'add',
                title: '新增商城配置'
            };
            this.actData = {
                begin_time: ''
            };
            this.groupList = [];
            this.$refs.dislog.show = true;
        },
        getMallList() {
            this.api.getAppMallList(this.searchData).then(data => {
                this.listData = data.data.list || [];
                this.total = data.data.total || 0;
            })
        },
        getGroupList() {
            this.api.getGroupList({}).then(data => {
                this.group = data.data.result;
            })
        },
        updateConfirm() {
            this.$refs.formRule.validate(v => {
                if(v) {
                    this.actData.group_list = this.groupList.join(';');
                    this.api.updateAppMall(this.actData).then(data => {
                        if(data.code == 200) {
                            this.$message.success('操作成功！');
                            this.getMallList();
                            this.$refs.dislog.show = false;
                        }
                    })
                }
            })
            
        },
        updateStatus(item, status) {
            this.actData = {...item};
            this.actData.status = status;
            this.$refs.tip.show = true;
        },
        updateStatusConfirm() {
            this.api.updateAppMall(this.actData).then(data => {
                this.$message.success('操作成功！');
                this.getMallList();
                this.$refs.tip.show = false;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getMallList();
        },
    }
})
</script>
<style lang="less" scoped>
    .margin_top{
        margin-top: 10px;
    }
    .btn_box{
        .sort_box{
            display: inline-block;
            float: right;
            .sort{
                background: #E4F9F8;
                border-color: #E4F9F8;
                color: #00D6B9;
                &.back{
                    background: #F0F5FE;
                    border-color: #5192FF;
                    color: #507FF7;
                }
            }
        }
        @media (max-width: 500px){
            .button{
                width: 80px;
            }
        }
    }
    .state{
        color: #EB534B;
        &.state1{
            color: #000;
        }
        &.state2{
            color: #2A79FF;
        }
    }
    .upload{
        .flexLayout(flex-start, flex-end);
        /deep/.el-upload{
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            .banner_img,.banner_icon{
                width: 210px;
                height: 90px;
            }
            .banner_icon{
                text-align: center;
                line-height: 90px;
                color: @colorBlue2;
                font-weight: 600;
            }
        }
        .el-upload__tip{
            color: #999;
        }
    }

    
</style>



// WEBPACK FOOTER //
// src/view/app/market-manage/mall-manage.vue